import App from "./App.svelte";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";
firebase.initializeApp({
    apiKey: "AIzaSyDZgmCM-M-PEu5iyKuCqAAFCmYgtTVKvkU",
    authDomain: "crypto-syncer.firebaseapp.com",
    projectId: "crypto-syncer",
    storageBucket: "crypto-syncer.appspot.com",
    messagingSenderId: "382299809831",
    appId: "1:382299809831:web:7eae248a71f359cd250602",
    measurementId: "G-R86RPH14CG",
});
firebase.analytics();
if (process.env.NODE_ENV !== "production") {
    firebase.functions().useEmulator("localhost", 5001);
    firebase.auth().useEmulator("http://localhost:9099");
    firebase.firestore().useEmulator("localhost", 8080);
}
const app = new App({
    target: document.body,
});
export default app;
